import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "sm-fs-base" }, "Select the Method of Request ", -1)
const _hoisted_3 = { class: "radio-group primary bold mt-20" }
const _hoisted_4 = { class: "radio-buttons gap-20 w-100 flex-column flex-md-row" }
const _hoisted_5 = { class: "radio-button flex-column enlarged h-100 bordered-card bordered-card_secondary bg-tertiary w-25 w-sm-100 align-items-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "body-text",
  for: "upload"
}, " Upload Excel file with Employee(s) SSN ", -1)
const _hoisted_7 = { class: "radio-button flex-column enlarged h-100 bordered-card bordered-card_secondary bg-tertiary w-25 w-sm-100 align-items-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "body-text",
  for: "web_form"
}, " Enter Employee(s) SSN via Web Request Form ", -1)
const _hoisted_9 = { class: "w-100 d-flex align-items-center justify-content-between gap-20 sm-mb-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "upload",
              name: "RequestMethod",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
              value: 0
            }, null, 512), [
              [_vModelRadio, _ctx.selectedOption]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "web_form",
              name: "RequestMethod",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOption) = $event)),
              value: 1
            }, null, 512), [
              [_vModelRadio, _ctx.selectedOption]
            ]),
            _hoisted_8
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "btn btn-secondary sm-mb-20",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
      }, "Back"),
      _createElementVNode("button", {
        class: "btn btn-primary sm-mb-20",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args)))
      }, "Next")
    ])
  ], 64))
}